import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Senior Data Engineer",
          "Cloud Data Architect",
          "ETL & Pipeline Builder",
          "Streaming & Analytics Expert",
          "DevOps + DataOps Engineer",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
